export enum ToastType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}
